"use client"
import { BlockType } from "@/libs/types"
import clsx from "clsx"
import React from "react"
interface FAQProps {
    locale: string
    variant: "h1" | "h2" | "h3" | "h4"
    block: BlockType,
    className?: string
}

const FAQ: React.FC<FAQProps> = ({ block }) => {
    if (block.title === null && block.content === null) return null;

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [open, setOpen] = React.useState<boolean>(false)

    return (
        <>
            <div className="justify-content-center faq" onClick={() => setOpen(!open)}>
                <div className={clsx("p-4 rounded border w-100", open ? "open-faq" : "")}>
                    <div className="d-flex text-start justify-content-between justify-item-center">
                        <h5 className="fw-semi-bold">{block.title}</h5>
                        <i className={clsx("img", "my-auto", "arrow-down")} />
                    </div>
                    <p className="description">{block.content}</p>
                </div>
            </div>
        </>
    )
}

export default FAQ